import React, { useEffect, useState } from 'react';
import Container from '../layout/Container';
import SectionTitle from '../ui/SectionTitle';
import ServiceCard from '../cards/ServiceCard';
import { services as staticServices } from '../../data/services';
import { publicApi } from '../../services/publicApi';

const Services = () => {
  const [services, setServices] = useState(staticServices);

  useEffect(() => {
    let isMounted = true;
    const loadServices = async () => {
      try {
        const data = await publicApi.getServiceOverviews();
        if (!Array.isArray(data) || data.length === 0 || !isMounted) return;

        const mapped = data
          .filter((item) => item.isActive !== false)
          .sort((a, b) => (a.displayOrder || 0) - (b.displayOrder || 0))
          .map((item) => ({
            id: item.slug,
            title: item.title,
            icon: item.icon,
            description: item.shortDescription,
          }));
        setServices(mapped);
      } catch {
        // Keep static fallback services.
      }
    };

    loadServices();
    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <Container id="services" className="bg-white dark:bg-black transition-colors duration-300">
      <SectionTitle 
        title="What We Do" 
        subtitle="Our Services" 
      />
      
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {services.map((service, index) => (
          <ServiceCard key={service.id} service={service} index={index} />
        ))}
      </div>
    </Container>
  );
};

export default Services;
